<div
  [style.background-image]="getBackground()"
  class="flex flex-col max-h-[100vh] overflow-y-auto ef-scrollbar"
  [ngClass]="{
    'min-h-[100vh] bg-cover bg-center': isMobileLogin
  }"
>
  <customer-portal-app-revolution-header
    [isMobileLogin]="isMobileLogin()"
    [ngClass]="{ 'md:hidden': countryCode === 'de' }"
    [includeLocalizationMenu]="countryCode === 'ch' || !countryCode"
  ></customer-portal-app-revolution-header>

  <div class="flex-1 w-full grid grid-cols-1 lg:grid-cols-12">
    <div
      class="hidden md:block md:min-h-[280px] lg:col-span-5 bg-cover bg-top md:bg-center"
      [style.background-image]="backgroundUrl"
      *ngIf="countryCode === 'ch' || !countryCode"
    ></div>
    <!-- prettier-ignore -->
    <customer-portal-lib-container
      class="hidden md:block md:min-h-[280px] lg:max-h-full lg:col-span-5 bg-cover bg-top md:bg-center"
      *ngIf="countryCode === 'de' || !countryCode" [texts]="[
    'The easiest way to care for your vehicles' | translate:{ _key: 'customerPortal.kc.jumbo.text.1', _tags: 'kc-forms, 3.1'},
    'Car service and leasing data at a glance' | translate:{ _key: 'customerPortal.kc.jumbo.text.2', _tags: 'kc-forms, 3.1'},
    'Easy appointments and advanced services' | translate:{ _key: 'customerPortal.kc.jumbo.text.3', _tags: 'kc-forms, 3.1'}
    ]">
    </customer-portal-lib-container>
    <div class="hidden lg:block md:col-span-1"></div>
    <div class="md:col-span-6 min-h-[720px] flex flex-col lg:justify-center">
      <customer-portal-app-revolution-login
        [isMobileLogin]="isMobileLogin()"
        class="flex-1 flex flex-col"
        *ngIf="view === 'login'"
      >
      </customer-portal-app-revolution-login>
      <customer-portal-app-revolution-reset-password
        class="flex-1 flex flex-col"
        *ngIf="view === 'reset-password'"
      >
      </customer-portal-app-revolution-reset-password>
      <customer-portal-app-revolution-update-password
        class="flex-1 flex flex-col"
        *ngIf="view === 'update-password'"
      >
      </customer-portal-app-revolution-update-password>
      <customer-portal-app-revolution-set-password
        class="flex-1 flex flex-col"
        *ngIf="view === 'set-password'"
      >
      </customer-portal-app-revolution-set-password>
      <customer-portal-app-revolution-error
        class="flex-1 flex flex-col"
        *ngIf="view === 'error'"
      >
      </customer-portal-app-revolution-error>

      <customer-portal-app-revolution-saml-post *ngIf="view==='saml-post'">

      </customer-portal-app-revolution-saml-post>

      <customer-portal-app-revolution-info
        class="flex-1 flex flex-col"
        *ngIf="view === 'info'"
      >
      </customer-portal-app-revolution-info>
      <customer-portal-app-revolution-register-business-invite
        class="flex-1 flex flex-col"
        *ngIf="view === 'register-business-invite'"
      ></customer-portal-app-revolution-register-business-invite>
      <customer-portal-app-revolution-request-business-invite
        class="flex-1 flex flex-col"
        *ngIf="view === 'request-business-invite'"
      ></customer-portal-app-revolution-request-business-invite>
      <customer-portal-app-revolution-activation-finish
        class="flex-1 flex flex-col"
        *ngIf="view === 'activation-finish'"
      >
      </customer-portal-app-revolution-activation-finish>

      <customer-portal-app-revolution-register
        *ngIf="view === 'register'"
      ></customer-portal-app-revolution-register>
      <customer-portal-revolution-personalize-new
        [view]="view"
        *ngIf="view === 'personalize-new'"
      ></customer-portal-revolution-personalize-new>

      <customer-portal-revolution-telephone-validation
        *ngIf="view === 'telephone-validation'"
      >
      </customer-portal-revolution-telephone-validation>

      <customer-portal-revolution-login-webwidget
        class="flex-1 flex flex-col"
        *ngIf="view === 'login-widget'"
      >
      </customer-portal-revolution-login-webwidget>

      <customer-portal-app-kc-request-business-sent
        *ngIf="view === 'request-business-sent'"
      >
      </customer-portal-app-kc-request-business-sent>
      <customer-portal-revolution-personalize-new
        [view]="view"
        *ngIf="view === 'personalize'"
      ></customer-portal-revolution-personalize-new>

      <customer-portal-revolution-register-finish
        *ngIf="view === 'register-finish'"
      ></customer-portal-revolution-register-finish>

      <customer-portal-kc-register-business-invite-finish
        *ngIf="view === 'register-business-invite-finish'"
      >
      </customer-portal-kc-register-business-invite-finish>

      <customer-portal-revolution-choose-existing
        *ngIf="view === 'choose-existing'"
      ></customer-portal-revolution-choose-existing>

      <customer-portal-revolution-enter-telephone
        *ngIf="view === 'enter-telephone'"
      ></customer-portal-revolution-enter-telephone>

      <!--
        <customer-portal-kc-reset-password *ngIf="view == 'reset-password'"></customer-portal-kc-reset-password>
        -->
      <!-- <customer-portal-kc-update-password *ngIf="view == 'update-password'"></customer-portal-kc-update-password> -->
      <!-- <customer-portal-kc-activation-finish *ngIf="view == 'activation-finish'"></customer-portal-kc-activation-finish> -->
      <!-- <customer-portal-kc-set-password *ngIf="view == 'set-password'"></customer-portal-kc-set-password> -->
      <customer-portal-revolution-gdpr
        *ngIf="view === 'consents' && hasNewGDPR"
      ></customer-portal-revolution-gdpr>
      <customer-portal-revolution-consents
        *ngIf="view === 'consents' && !hasNewGDPR"
      ></customer-portal-revolution-consents>

      <customer-portal-kc-company-details
        *ngIf="view === 'company-details'"
      ></customer-portal-kc-company-details>

      <customer-portal-kc-company-request-change
        *ngIf="view === 'company-request-change'"
      >
      </customer-portal-kc-company-request-change>

      <customer-portal-revolution-vin-validation
        *ngIf="view === 'vin-validation'"
      >
      </customer-portal-revolution-vin-validation>

      <customer-portal-app-revolution-email-change
        *ngIf="view === 'email-change'"
      >
      </customer-portal-app-revolution-email-change>
    </div>
  </div>

  <span class="hidden md:block">
    <customer-portal-app-revolution-footer
      *ngIf="countryCode === 'ch' || !countryCode"
    ></customer-portal-app-revolution-footer>
    <customer-portal-lib-footer-new
      *ngIf="countryCode === 'de'"
    ></customer-portal-lib-footer-new>
  </span>
</div>
